export { CustomLabelDialogComponent as Component } from './custom-label-dialog.component'
